function getHUTK() {
  return typeof document === `undefined` ? '' : (document.cookie.match(/\bhubspotutk=([^;]+)/) || ['', ''])[1]
}

export async function submitHubspotForm(form: HTMLFormElement) {
  const action = form.getAttribute('action') || '/hubspot'
  const formData = new FormData(form)

  // add hubspot cookie to the form data
  const hutk = getHUTK()
  if (hutk.length) {
    formData.append('hutk', hutk)
  }

  const response = await fetch(action, {
    method: 'POST',
    headers: { 'Content-Type': `application/json;charset=utf-8` },
    body: JSON.stringify(Object.fromEntries(formData)),
  })
  const data = await response.json()
  return data
}
